<template>
  <!-- 党的建设查看更多二级页 -->
  <div>
    <div class="dsxxpage-content">
      <!--面包屑-->
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>每周精选</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="dsxqy-cont">
        <div style="margin-top: 30px">
          <div class="dsxqy-cont-down" v-for="(item,i) in list" :key="item.id" v-loading="loading">
            <span class="title">{{ item.columnName }}</span>
            <ul>
              <li v-for="(it, index) in data[i]" :key="index">
                <a :href="it.nodeUrl" target="_blank">{{ it.title }}</a>
                <span>{{ it.pubDate&&it.pubDate.slice(0,10) }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { djsxMixin } from "../mixins/mixin";
export default {
  mixins: [djsxMixin],
  data() {
    return {
      loading:false,
      i:0
    };
  },
  methods: {
    getDetail(uid) {
      this.axios.post("data/cnki/getKbaseList",{
        uid: uid,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        sign:'更多'
      }).then((res) => {
        if (res.status == 200) {
          this.data.push(res.data.rows)
          if(this.i<this.list.length-1) {
            this.i+=1
            this.getDetail(this.list[this.i].uid)
          }
          // if(i===this.list.length-1) this.loading = false
        } else {
          this.$message.error("获取失败！");
        }
      });
    },
  },
};
</script>

<style  lang="scss" scoped>
.dsxxpage-content {
  width: 1200px;
  height: auto;
  margin: 30px auto;
  margin-bottom: 70px;
  .breadcrumb {
    position: relative;
    box-sizing: border-box;
    padding-left: 20px;
    .el-breadcrumb {
      font-size: 16px;
    }
  }
  .breadcrumb:before {
    content: "";
    position: absolute;
    left: 0;
    display: inline-block;
    width: 17px;
    height: 16px;
    background: url("../assets/images/dzdgpage_arr.png") no-repeat;
  }
  .dsxxpage-cont {
    position: relative;
    height: auto;
    margin-top: 20px;
  }
  .dsxqy-cont {
    .dsxqy-cont-down {
      width: 1200px;
      margin: 15px 0 50px;
      box-sizing: border-box;
      padding: 16px 30px 0 30px;
      background: url("../assets/images/dnhd-dwbg.png") repeat-x;
      .title{
        display: block;
        font-size: 20px;
        font-weight: bold;
        color: #de1c26;
        margin-bottom: 5px;
      }
      li {
        position: relative;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        line-height: 40px;
        a {
          margin-left: 18px;
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: calc(100% - 141px);
          &:hover{
            color: #BD1A2D;
          }
        }
      }
      li:before {
        position: absolute;
        top: 14px;
        content: "";
        display: inline-block;
        width: 8px;
        height: 12px;
        background: url("../assets/images/vector.png") no-repeat;
      }
      p {
        text-align: right;
        font-size: 16px;
        margin-top: 10px;
        a {
          color: #9f9fa6;
        }
      }
    }
  }
   :deep(.block) {
    margin-top: 40px;
    text-align: center;
  }
}
</style>